import { createAction } from '@reduxjs/toolkit';

export const analyzeFlyout = createAction<{
  path: string[],
  url: string,
  position: number,
}>('analyzeFlyout');
